module.exports = __webpack_public_path__ + "img/menu.8f92c241.svg";